import { TEAM_DIALOG_TABS } from "@/store/dialog/TeamDialogStore";

import type { TeamDialogTab } from "@/store/dialog/TeamDialogStore";

const PARAMS = { tab: "settings", team: "team" } as const;

export type TeamDialogLink = {
  tab: TeamDialogTab;
  teamPermalink?: string;
};

export function withTeamDialogLink(path: string, { tab, teamPermalink }: TeamDialogLink) {
  const url = new URL(path, "http://localhost");
  url.searchParams.set(PARAMS.tab, tab);
  if (teamPermalink) url.searchParams.set(PARAMS.team, teamPermalink);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function parseTeamDialogLink(params: URLSearchParams): TeamDialogLink | null {
  const requestedTab = params.get(PARAMS.tab);
  const tab = TEAM_DIALOG_TABS.find((knownTab) => knownTab === requestedTab);
  if (!tab) return null;

  return { tab, teamPermalink: params.get(PARAMS.team) ?? undefined };
}

export function consumeTeamDialogLink() {
  const url = new URL(window.location.href);
  url.searchParams.delete(PARAMS.tab);
  url.searchParams.delete(PARAMS.team);
  url.searchParams.delete("stripe_checkout_session_id");
  window.history.replaceState(null, "", url);
}
